import PropTypes from 'prop-types';
import {
  Box,
  Card,
  CardContent,
  Typography,
  makeStyles,
} from '@material-ui/core';
import {
  Storefront as StorefrontIcon,
  AccountBalance as AccountBalanceIcon,
} from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  card: {
    borderRadius: 8,
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    height: 120,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#fafafa', // leve diferencia visual
  },
  content: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  leftSection: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    fontSize: 28,
    marginRight: theme.spacing(2),
  },
  salesIcon: {
    color: '#FF6B35',
  },
  depositIcon: {
    color: '#4CAF50',
  },
  title: {
    fontSize: 14,
    fontWeight: 600,
  },
  date: {
    fontSize: 12,
    color: '#888',
  },
  amount: {
    fontSize: 20,
    fontWeight: 'bold',
  },
}));

function DashboardSmallCard({ type, title, amount = 0, date }) {
  const classes = useStyles();

  const formatCurrency = (value) =>
    new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 2,
    }).format(value);

  const isSales = type === 'sales';

  const IconComponent = isSales ? StorefrontIcon : AccountBalanceIcon;
  const iconClass = isSales ? classes.salesIcon : classes.depositIcon;

  return (
    <Card className={classes.card}>
      <CardContent className={classes.content}>
        <Box className={classes.leftSection}>
          <IconComponent className={`${classes.icon} ${iconClass}`} />
          <Box>
            <Typography className={classes.title}>
              {title}
            </Typography>
            <Typography className={classes.date}>
              {date}
            </Typography>
          </Box>
        </Box>

        <Typography className={classes.amount}>
          {formatCurrency(amount).replace('MX$', '')}
          <span style={{
            fontSize: 12,
            marginLeft: 4,
            color: '#999',
          }}>
            MXN
          </span>
        </Typography>
      </CardContent>
    </Card>
  );
}

DashboardSmallCard.propTypes = {
  type: PropTypes.oneOf(['sales', 'deposit']).isRequired,
  title: PropTypes.string,
  amount: PropTypes.number,
  date: PropTypes.string,
};

export default DashboardSmallCard;
